import React, {useEffect, useRef, useState} from 'react';

import Lottie from 'react-lottie';

import styled, {css} from 'styled-components';

import {useIsCartoonito} from '../../helpers';
import CNLoader from './../../assets/animations/CNLoader.json';
// eslint-disable-next-line max-len
import CNLoaderRefreshed from './../../assets/animations/CNApp_Refreshed_Loader.json';
import {
    colors,
    mobileMediaQuery,
    tabletMediaQuery,
    tabletPortraitMediaQuery,
} from '../../styles';

const Container = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    ${props => props.padding && `padding: ${props.padding};`};
    ${props => props.margin && `margin: ${props.margin};`};
    * {
        pointer-events: none;
    }
    background-color: ${({background}) => background | '#000'};

    div:first-child {
        max-width: 100%;

        ${tabletMediaQuery} {
            max-width: 250px;
        }

        ${tabletPortraitMediaQuery} {
            max-width: 300px;
        }

        ${mobileMediaQuery} {
            max-width: 270px;
        }
    }

    ${({hide}) =>
        hide &&
        css`
            transition: opacity 0.6s linear;
            opacity: 0;
            pointer-events: none;
            position: fixed;
            height: auto;
            top: ${({top}) => top | 0}px;
            z-index: 100;
        `}
`;

const ProgressBar = styled.div`
    background-color: #fff;
    position: relative;
    width: 350px;
    height: 9px;

    ${tabletMediaQuery} {
        max-width: 250px;
    }

    ${tabletPortraitMediaQuery} {
        max-width: 300px;
    }

    ${mobileMediaQuery} {
        max-width: 270px;
    }

    ::after {
        content: '';
        position: absolute;
        background-color: ${colors.pink};
        width: 0%;
        height: 100%;
        top: 0px;
        left: 0px;
        bottom: 0px;
        transition: width 10s ease-in-out;
        ${props =>
            props.duration ? `transition-duration: ${props.duration}s` : ''};
        ${props => `width: ${props.progress}%`};
    }
`;

const Loader = ({hide, background, ...props}) => {
    const containerRef = useRef();

    const isCartoonito = useIsCartoonito();
    const [progress, setProgress] = useState(0);
    const [duration, setDuration] = useState(5);
    const [isClosing, setIsClosing] = useState(false);
    const [top, setTop] = useState(undefined);

    useEffect(() => {
        setProgress(25);

        setTimeout(() => {
            setDuration(10);

            setTimeout(() => {
                setProgress(95);
            }, 100);
        }, 5000);

        return () => {
            handleClose();
        };
    }, []);

    useEffect(() => {
        if (hide) {
            handleClose();
        }
    }, [hide]);

    const handleClose = () => {
        var viewportOffset = containerRef.current.getBoundingClientRect();

        setIsClosing(true);
        setTop(viewportOffset.top);
        setDuration(0.5);
        setProgress(100);
    };

    return (
        <Container
            ref={containerRef}
            hide={isClosing}
            background={background}
            top={top}
            {...props}
        >
            <Lottie
                options={{
                    loop: true,
                    autoplay: true,
                    animationData: isCartoonito ? CNLoader : CNLoaderRefreshed,
                    isClickToPauseDisabled: true,
                    isStopped: false,
                    isPaused: false,
                }}
                width={isCartoonito ? 400 : 350}
                height="auto"
            />
            {!isCartoonito && (
                <ProgressBar progress={progress} duration={duration} />
            )}
        </Container>
    );
};

export default Loader;
